"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calcFunction_1 = require("./calcFunction");
var aggregateFunction_1 = require("./aggregateFunction");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
var schemaMethods = require("../schemaMethods");
/**
 * pobranie wartości z modelu przy użyciu Proxy
 *
 * @param {JSONSchema} schema
 * @param {*} proxy
 * @param {*} target
 * @param {(string | number)} property
 * @param {*} options
 * @param {*} parent
 * @returns
 */
function getValue(schema, proxy, target, property, options, parent) {
    // console.log("get", target, property, schema);
    var v = target[property];
    if (v === undefined && schema.default !== undefined) {
        v = schema.default;
    }
    var func;
    if (schema.calc) {
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        func = schema.cache.calcFunc;
        if (func === undefined) {
            // func = schema.cache.calcFunc = new Function(schema.calc);
            func = schema.cache.calcFunc = (0, calcFunction_1.default)(schema, false, process.env.NODE_ENV === 'development' && schema.debug);
        }
        // tslint:disable-next-line: max-line-length
        // return func.apply(proxy, [options.$root, parent, parent.$parent, parent.$parent.$parent,options.$methods,options.$external]);
    }
    else if (schema.aggregate) {
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        func = schema.cache.aggregateFunc;
        if (func === undefined) {
            // func = schema.cache.calcFunc = new Function(schema.calc);
            func = schema.cache.aggregateFunc = (0, aggregateFunction_1.default)(schema, false, process.env.NODE_ENV === 'development' && schema.debug);
        }
    }
    if (func) {
        var path = proxy.$path;
        if (typeof property === 'string') {
            path = path ? path + '.' + property : property;
        }
        else {
            path += '[' + property + ']';
        }
        var calcargs = [
            options.$root,
            parent || {},
            parent ? parent.$parent || {} : {},
            parent && parent.$parent ? parent.$parent.$parent || {} : {},
            options.external || {},
            options.schemaMethods || {},
            {
                $key: property,
                $path: path,
                $model: v
            }
        ];
        try {
            v = func.apply(proxy, calcargs);
        }
        catch (_a) {
            // v = undefined;
        }
    }
    return v;
}
/**
 * zwraca Proxy dla danych typu array
 *
 * @param {JSONSchema} schema schemat danych
 * @param {*} data dane
 * @param {*} options opcje
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @returns {*} zwraca Proxy obudowujące tablicę
 */
function getArrayProxy(schema, data, options, parent, key) {
    var proxy;
    var items = schema.items;
    var handler = {
        get: function (target, index, receiver) {
            if (index === '$parent') {
                return parent;
            }
            if (index === '$key') {
                return key;
            }
            if (items) {
                var v = getValue(items, proxy, target, index, options, parent);
                if (v !== undefined && v !== null) {
                    switch (items.type) {
                        case 'object':
                            return getObjectProxy(items, v, options, proxy, index);
                        case 'array':
                            return getArrayProxy(items, v, options, proxy, index);
                    }
                }
                return v;
            }
            return undefined;
        }
    };
    proxy = new Proxy(data, handler);
    return proxy;
}
/**
 * zwraca Proxy dla danych typu object
 *
 * @param {JSONSchema} schema schemat danych
 * @param {*} data dane
 * @param {*} options opcje
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @returns {*} zwraca Proxy obudowujące obiekt
 */
function getObjectProxy(schema, data, options, parent, key) {
    var proxy;
    var props = schema.properties;
    var handler = {
        get: function (target, name) {
            if (name === '$parent') {
                return parent;
            }
            if (name === '$key') {
                return key;
            }
            if (name === '$path') {
                var path = '';
                if (parent) {
                    path = parent.$path;
                }
                return path ? path + '.' + key : key || '';
            }
            if (props) {
                var field = props[name];
                if (field) {
                    var v = getValue(field, proxy, target, name, options, parent);
                    if (v !== undefined && v !== null) {
                        switch (field.type) {
                            case 'object':
                                return getObjectProxy(field, v, options, proxy, name);
                            case 'array':
                                return getArrayProxy(field, v, options, proxy, name);
                        }
                    }
                    return v;
                }
                else {
                    return undefined;
                }
            }
            return undefined;
        }
    };
    proxy = new Proxy(data, handler);
    if (options.$root === undefined) {
        options.$root = proxy;
    }
    return proxy;
}
/**
 * obudowuje model danych przez Proxy, dzięki czemu zwraca np. domyślne wartości gdy pola nie ma,
 * lub wartości wyliczone dla pól wyliczalnych
 *
 * @export
 * @param {JSONSchema} schema schemat danych, najelpiej jak jest naprawiony przez fixAndMergeSchema
 * @param {*} data dane do obudowania, typu object
 * @param {*} [external] dane zewnętrzne używane w kalkulacjach
 * @returns {*} obiekt typu Proxy
 */
function schemaProxy(schema, data, external) {
    if (schema.$parent === undefined) {
        if (Array.isArray(schema)) {
            schema = (0, fixAndMergeSchema_1.default)(schema);
        }
        else {
            schema = (0, fixAndMergeSchema_1.default)([schema]);
        }
    }
    return getObjectProxy(schema, data, { external: external || {}, schemaMethods: schemaMethods });
}
exports.default = schemaProxy;
//# sourceMappingURL=schemaProxy.js.map